// export const API_ROOT = 'http://54.226.8.113:9999/api/';
export const API_ROOT = 'https://genius.fybr-tech.com/api/';
// export const API_ROOT = "http://3.213.177.237:9999/api/";
// export const API_ROOT = 'https://devteam.fybr-tech.com/api/';
